import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


const FreeWash=()=>{

   const {t}= useTranslation();


    return (
    <div dir={i18next.language === "ar" ? "rtl" : "ltr"} className="group cursor-pointer w-full my-2 shadow-2xl">
      <div className="bg-white rounded-2xl border-2 border-gray-100 hover:border-[#66B8D9]/30 shadow-sm hover:shadow-xl transition-all duration-300 p-6">
        <Link to="/login" className="flex items-center gap-5">
          <div className="relative">
            <div className="w-16 h-16 bg-gradient-to-br from-[#66B8D9] to-[#4E98B9] rounded-2xl flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
              <svg
                className="w-9 h-9 text-white"
                viewBox="0 0 87 87"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M39.5896 76.1436L36.4191 65.5644C33.6712 56.4664 26.5903 49.3783 17.5013 46.6277L6.93278 43.454C3.02241 42.2903 3.02241 36.7891 6.93278 35.6254L17.5013 32.4516C26.5903 29.701 33.6712 22.613 36.4191 13.5149L39.5896 2.93572C40.7522 -0.978574 46.2478 -0.978574 47.4104 2.93572L50.5809 13.5149C53.3288 22.613 60.4097 29.701 69.4987 32.4516L80.0672 35.6254C83.9776 36.7891 83.9776 42.2903 80.0672 43.454L69.4987 46.6277C60.4097 49.3783 53.3288 56.4664 50.5809 65.5644L47.4104 76.1436C46.2478 79.9521 40.7522 79.9521 39.5896 76.1436Z"
                />
              </svg>
            </div>
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-white"></div>
          </div>
          
          <div className="flex-1">
            <h3 className="text-xl font-bold text-gray-900 mb-1 group-hover:text-[#4E98B9] transition-colors">
              {t('getfreewash')}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              {t('regfreewash')}
            </p>
          </div>
          
          <div className="flex-shrink-0">
            <div className="w-10 h-10 rounded-full bg-gray-50 group-hover:bg-[#66B8D9] flex items-center justify-center transition-all duration-300">
              <svg  className={`w-5 h-5 text-gray-400 group-hover:text-white transition-colors  ${i18next.language === "ar" ? "-scale-x-100" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </Link>
      </div>
    </div>
    );}

export default FreeWash;